import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'complete',
  templateUrl: './complete.component.html',
  styleUrls: ['./complete.component.scss']
})
export class CompleteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
